/* eslint-disable @typescript-eslint/consistent-type-imports */
// import { graphql } from 'react-relay';
import isEqual from 'lodash/isEqual';

// import { writeQueryInterop } from '@confluence/apollo-relay-interop/entry-points/writeQuery';
import { getClientStream } from '@confluence/ssr-data-streaming/entry-points/client.ts';

import { Event } from './streaming.ts';

type ResultError = {
	message: string;
	path: string[];
	locations: any;
};

type Result = {
	result: any;
	errors: ResultError[];
};

function hasRootLevelErrors(eventResult: Result): boolean {
	if (!Array.isArray(eventResult.errors)) {
		return false;
	}

	return eventResult.errors.some((error: ResultError) => error.path && error.path.length === 1);
}

export class RelayQueryResultCache {
	private queryResults: Map<string, { result: object; variables: object }[]>;

	/**
	 * The listener for the client stream to cache the query results is set in this constructor.
	 */
	constructor(namespace: string) {
		this.queryResults = new Map();

		const data = getClientStream(namespace);

		data.addListener((event: Event): void => {
			if (event.type === 'result') {
				if (!hasRootLevelErrors(event.result)) {
					this.addResult(event.operation, event.result.data, event.variables);
				}
			}
		});
	}

	getMatchingResult(query: string, variables: object): object | null {
		const results = this.queryResults.get(query);

		if (!results) {
			return null;
		}

		const matchingQueryResult = results.findIndex((result) => isEqual(result.variables, variables));

		if (matchingQueryResult === -1) {
			return null;
		}

		const matchingData = results[matchingQueryResult].result;
		results.splice(matchingQueryResult, 1);
		this.queryResults.set(query, results);
		return matchingData;
	}

	addResult(query: string, result: object, variables: object): void {
		const results = this.queryResults.get(query) || [];
		results.push({ result, variables });
		this.queryResults.set(query, results);
	}
}
